"use strict";
angular.module("orgDetailViewAlertModule", [
    "organizationDetailsModule"
]).
factory("orgDetailViewAlert", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * 组织用户查看详情
         */
        orgDetailsViewAlert: function(id) {
            // var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/organizationManagement/orgDetailsView/orgDetailsView_tpl.html",
                windowClass: 'orgDetailsView backstageModalHeader',
                backdrop: false,
                controller: "organizationDetailsCtrl",
                resolve: {
                    openedData:function(){
              			return id;
              		}
                }
            });
            // modalInstance.result.then(function(result) {
            //     deffer.resolve(result);
            // });
            // return deffer.promise;
        },
    };
}]);